/* eslint-disable react/no-danger */
import React from 'react';
import translate from '@/lib/intl/translate';

type IntegrationHelperStepProp = {
  children?: React.ReactNode;
  description?: string;
  stepNumber: number;
};

function IntegrationHelperStep({
  children,
  description,
  stepNumber,
}: IntegrationHelperStepProp) {
  return (
    <div className="border-b border-grey-300 p-3 md:p-6">
      <div className="border-l-8 border-secondaryButton-main px-3 md:px-4">
        <div className="mb-3 w-8 whitespace-nowrap border-b-2 border-grey-600 pb-3 text-sm md:mb-4 md:pb-4 md:text-base">
          {translate('INTEGRATIONS_STEP_NUMBER', { number: stepNumber })}
        </div>
        {description && (
          <div
            className="type-body3 md:type-body1"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {children && <div className="type-body3 md:type-body1">{children}</div>}
      </div>
    </div>
  );
}

export default IntegrationHelperStep;
